var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file"},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.file.id)+" ")]),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"status"},[_vm._v(" "+_vm._s(_vm.file.uptime)+" ")]),_c('ma-more',{staticClass:"bly-more icon-btn ma-btn"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }